import { render } from "./Wares.vue?vue&type=template&id=b0dd4d9c&ts=true"
import script from "./Wares.vue?vue&type=script&lang=ts"
export * from "./Wares.vue?vue&type=script&lang=ts"

import exportComponent from "D:\\Project\\wallet\\wallet-pc\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__